module.exports = __webpack_public_path__ + "static/media/building 02.d2a1bdbc.png";